package com.klantenstop.web.pages.sections

import androidx.compose.runtime.Composable
import com.klantenstop.web.components.NavigationItems
import com.klantenstop.web.navigation.Navigation
import com.klantenstop.web.utils.Constants
import com.klantenstop.web.utils.Res
import com.klantenstop.web.utils.logoImage
import com.materialkobweb.components.sections.NavHeaderIdentifiers
import com.materialkobweb.components.sections.NavigationItem
import com.materialkobweb.components.sections.NavigationItemStyle
import com.materialkobweb.components.widgets.DsFlexBox
import com.materialkobweb.styles.MaterialColorVars
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UndecoratedLinkVariant
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import kotlin.js.Date

@Composable
fun FooterSection(showMenuItems: Boolean, modifier: Modifier = Modifier) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .padding(topBottom = 48.px)
            .backgroundColor(MaterialColorVars.SurfaceContainer.value())
            .then(modifier),
        contentAlignment = Alignment.Center
    ) {
        FooterContent(showMenuItems)
    }
}

@Composable
fun FooterContent(showMenu: Boolean) {
    val wide = rememberBreakpoint() > Breakpoint.SM

    Column(
        modifier = Modifier
            .fillMaxWidth(if (wide) 80.percent else 90.percent)
            .maxWidth(Constants.SECTION_WIDTH.px),
        verticalArrangement = Arrangement.spacedBy(24.px)
    ) {
        DsFlexBox(
            modifier = Modifier.fillMaxWidth(),
            flexDirection = if (wide) FlexDirection.Row else FlexDirection.Column,
            justifyContent = if (wide) JustifyContent.SpaceBetween else JustifyContent.Start,
            gap = 36.px
        ) {
            FooterBrand()
            FooterNavigation(showMenu)
            FooterSocials()
        }

        Box(
            Modifier
                .fillMaxWidth()
                .height(1.px)
                .backgroundColor(MaterialColorVars.OutlineVariant.value())
        )

        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = if (wide) Arrangement.SpaceBetween else Arrangement.spacedBy(8.px),
            verticalAlignment = Alignment.CenterVertically
        ) {
            SpanText(
                text = "© ${Date().getFullYear()} KlantenStop",
                modifier = Modifier.fontSize(10.px).color(MaterialColorVars.OnSurfaceVariant.value())
            )
            Row(
                horizontalArrangement = Arrangement.spacedBy(4.px),
                verticalAlignment = Alignment.CenterVertically
            ) {
                val linkStyle = Modifier.fontSize(10.px)
                NavigationItem(
                    title = "Privacybeleid",
                    href = Navigation.Screen.PrivacyPolicy.route,
                    modifier = linkStyle
                )
                SpanText(
                    modifier = Modifier.fontSize(11.px).color(MaterialColorVars.OnSurfaceVariant.value()),
                    text = "·"
                )
                NavigationItem(
                    title = "Algemene Voorwaarden",
                    href = Navigation.Screen.TermsAndConditions.route,
                    modifier = linkStyle
                )
            }
        }
    }
}

@Composable
private fun FooterBrand() {
    Column(verticalArrangement = Arrangement.spacedBy(12.px)) {
        Image(
            modifier = Modifier.width(132.px),
            src = logoImage(ColorMode.current),
            alt = "KlantenStop logo"
        )
        SpanText(
            text = "Vind zorgverleners en dienstverleners zonder klantenstop.",
            modifier = Modifier
                .fontSize(12.px)
                .maxWidth(260.px)
                .color(MaterialColorVars.OnSurfaceVariant.value())
        )
    }
}

@Composable
private fun FooterNavigation(showMenu: Boolean) {
    Column(verticalArrangement = Arrangement.spacedBy(10.px)) {
        FooterHeading("Navigatie")
        if (showMenu) NavigationItems(true)
    }
}

@Composable
private fun FooterSocials() {
    Column(verticalArrangement = Arrangement.spacedBy(10.px)) {
        FooterHeading("Volg ons")

        Link(
            path = Constants.FACEBOOK_URL,
            variant = UndecoratedLinkVariant,
        ) {
            Row(
                modifier = NavigationItemStyle.toModifier()
                    .fillMaxWidth()
                    .cursor(Cursor.Pointer),
                horizontalArrangement = Arrangement.spacedBy(8.px),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Box(
                    Modifier
                        .size(16.px)
                        .backgroundColor(MaterialColorVars.OnSurface.value())
                        .styleModifier {
                            property("mask", "url(${Res.Image.facebook}) no-repeat center / contain")
                            property("-webkit-mask", "url(${Res.Image.facebook}) no-repeat center / contain")
                        }
                )

                SpanText(
                    text = "Facebook",
                    modifier = Modifier.fillMaxWidth()
                        .id(NavHeaderIdentifiers.navigationText)
                        .fontSize(12.px)
                )
            }
        }
    }
}

@Composable
private fun FooterHeading(text: String) {
    SpanText(
        text = text,
        modifier = Modifier.fontSize(12.px).fontWeight(700).color(MaterialColorVars.OnSurface.value())
    )
}
